import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function Percentage({ amount } : { amount: number | undefined}) {
    const amountToUse = amount ?? 0;
    return <CircularProgressbarWithChildren
        value={Math.round(amountToUse)}
        text={`${Math.round(amountToUse)}% full`}
        styles={{
            path: {
                // Path color
                strokeWidth: "9",
                stroke: "#4A7BFE",
                strokeLinecap: "butt",
                transition: 'stroke-dashoffset 0.8s ease 0s',
            },
            // Customize the circle behind the path, i.e. the "total progress"
            trail: {
                stroke: "#FCE3CD",
                //stroke: "#F1F2F2",
                strokeLinecap: "butt",
            },
            // Customize the text
            text: {
                // Text color
                fill: "#00266C",
                // Text size
                fontSize: "16px"
            },
            // Customize background - only used when the `background` prop is true
            background: {
                fill: "#FFAF21"
            }
        }}>
    </CircularProgressbarWithChildren>
}